"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSMenuScene = void 0;
const Game_1 = require("./Game");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
class TSMenuScene extends Phaser.Scene {
    constructor() {
        super("TSMenuScene");
    }
    create() {
        this.add.sprite(0, 0, 'board').setOrigin(0);
        this._h2p = this.add.sprite(0, 0, 'h2p').setOrigin(0);
        this._controls = this.add.sprite(0, 0, 'controls').setOrigin(0);
        this._box = this.add.sprite(0, 0, 'box').setOrigin(0);
        this._controller = Game_1.game_manager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        this._phase = 0;
        this._paperSound = this.sound.add('paper_slide');
        this._paperSound2 = this.sound.add('paper_slide2');
        this._boxSound = this.sound.add('box_slide');
    }
    start() {
    }
    update() {
        if (this._inputBlocked)
            return;
        if (this._controller.getInput(Game_1.Controls.Left).isJustDown()
            || this._controller.getInput(Game_1.Controls.Up).isJustDown()
            || this._controller.getInput(Game_1.Controls.Right).isJustDown()
            || this._controller.getInput(Game_1.Controls.Down).isJustDown()
            || this._controller.getInput(Game_1.Controls.Enter).isJustDown()) {
            this.goToNextPhase();
        }
    }
    goToNextPhase() {
        var _a, _b, _c;
        this._inputBlocked = true;
        switch (this._phase) {
            case 0:
                (_a = this._boxSound) === null || _a === void 0 ? void 0 : _a.play();
                this.tweens.add({
                    targets: this._box,
                    x: -64,
                    duration: 750,
                    ease: Phaser.Math.Easing.Sine.In,
                    onComplete: () => {
                        this._phase++;
                        this._inputBlocked = false;
                    }
                });
                break;
            case 1:
                (_b = this._paperSound) === null || _b === void 0 ? void 0 : _b.play();
                this.tweens.add({
                    targets: this._controls,
                    x: -64,
                    duration: 300,
                    ease: Phaser.Math.Easing.Sine.In,
                    onComplete: () => {
                        this._phase++;
                        this._inputBlocked = false;
                    }
                });
                break;
            case 2:
                (_c = this._paperSound2) === null || _c === void 0 ? void 0 : _c.play();
                this.tweens.add({
                    targets: this._h2p,
                    x: 64,
                    duration: 300,
                    ease: Phaser.Math.Easing.Sine.In,
                    onComplete: () => {
                        this.scene.start("TSGameScene", null);
                    }
                });
                break;
        }
    }
}
exports.TSMenuScene = TSMenuScene;
